import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "d-flex flex-row justify-content-around gap-16px p-5 pt-0 mt-38px" };
const _hoisted_2 = { class: "ps-5 pe-4 py-4" };
const _hoisted_3 = { class: "d-flex flex-row justify-content-between" };
const _hoisted_4 = { class: "d-flex flex-row justify-content-between" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = { class: "ps-5 pe-4 py-4" };
const _hoisted_7 = {
    key: 0,
    class: "premialita-text"
};
const _hoisted_8 = { class: "d-flex flex-row align-items-center" };
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
    class: "premialita-text ml-12px text-truncate",
    style: { "max-width": "170px" }
};
const _hoisted_11 = ["checked", "onChange"];
const _hoisted_12 = { class: "d-flex flex-row justify-content-between gap-16px" };
const _hoisted_13 = {
    class: "d-flex gap-2",
    style: { "justify-content": "end !important" }
};
import { onMounted, ref } from "vue";
import axios from 'axios';
import QRCode from "qrcode";
import BaseModal from '@/components/BaseModal.vue';
import ButtonComponent from '../components/Button.vue';
import { jsPDF } from "jspdf";
import { useToast } from 'vue-toast-notification';
import { validateNumericInput } from '../lib/utils';
import 'vue-toast-notification/dist/theme-sugar.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TypeBMuseumPremialita',
    props: {
        baseUrl: { type: String },
        token: { type: String },
        activities: { type: Object },
        campaignId: { type: String },
        museumId: { type: String }
    },
    emits: ["onUpdate"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const isLoading = ref(false);
        const getError = ref(null);
        const qrCanvas = ref(null);
        const showModalQR = ref(false);
        const item = ref({
            activity: {
                uuid: '',
                campaignId: props.campaignId,
                status: { id: 0, name: 'DRAFT' },
                points: 0,
                campaign: {
                    offers: []
                }
            },
            value: 0,
            visitType: 'REWARD - Ingresso museo tipo B',
            offers: []
        });
        let debounceTimer = null;
        const $toast = useToast();
        const generateQRCode = async () => {
            if (qrCanvas.value) {
                await QRCode.toCanvas(qrCanvas.value, props.museumId, {
                    width: 220,
                    margin: 2,
                });
            }
        };
        const downloadPDF = () => {
            const doc = new jsPDF();
            const canvas = qrCanvas.value;
            if (canvas) {
                const imgData = canvas.toDataURL("image/png");
                doc.text("QR Code generato", 10, 10);
                doc.addImage(imgData, "PNG", 10, 20, 100, 100);
                doc.save("qrcode.pdf");
            }
        };
        const toggleOffer = (offer) => {
            const offers = item.value.offers;
            const index = offers?.findIndex(o => o.uuid === offer.uuid);
            if (index === -1)
                offers.push(offer);
            else
                offers.splice(index, 1);
            handleUpdate();
        };
        const handleActivity = async () => {
            if (!item.value.activity?.uuid) {
                await handleCreate();
            }
            else {
                await handleDelete();
            }
        };
        const handleDelete = async () => {
            await activityAction('delete', `/${item.value.activity.uuid}`, null, 'Attività disattivata con successo');
        };
        const handleCreate = async () => {
            const data = {
                status: 'PUBLISHED',
                campaignId: props.campaignId,
                visitType: 'REWARD - Ingresso museo tipo B',
                points: 0,
                value: 0,
                offers: []
            };
            await activityAction('post', '', data, 'Attività attivata con successo');
        };
        const handleUpdate = async () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(async () => {
                const data = {
                    status: 'PUBLISHED',
                    campaignId: props.campaignId,
                    points: item.value.activity.points,
                    visitType: item.value.visitType,
                    value: item.value.value,
                    offers: item.value.offers.map(offer => offer.uuid)
                };
                await activityAction('put', `/${item.value.activity.uuid}`, data, 'Attività aggiornata con successo');
            }, 500);
        };
        const activityAction = async (method, path, data, msg) => {
            isLoading.value = true;
            try {
                await axios({
                    method,
                    url: `${props.baseUrl}/v1/private/museums/${props.museumId}/activity${path}`,
                    data,
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                });
                $toast.success(msg, { position: 'top-right' });
                emit('onUpdate');
            }
            catch (error) {
                console.error(error);
                getError.value = error;
                $toast.error(error.response.data.title, { position: 'top-right' });
            }
            finally {
                isLoading.value = false;
            }
        };
        onMounted(() => {
            if (props.activities.length > 0) {
                const activityOfCampaign = props.activities.filter(el => el.activity.campaign.uuid === props.campaignId)[0];
                if (activityOfCampaign)
                    item.value = activityOfCampaign;
            }
            generateQRCode();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "premialita-title" }, "Attività Premiante:", -1)),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "premialita-text pb-2" }, " Attiva: ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    style: { "cursor": "pointer" },
                                    "true-value": 1,
                                    "false-value": 2,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((item.value.activity.status.id) = $event)),
                                    onChange: handleActivity
                                }, null, 544), [
                                    [_vModelCheckbox, item.value.activity.status.id]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "premialita-text" }, " Assegna Punti: ", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "premialita-input",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((item.value.activity.points) = $event)),
                                    disabled: !item.value.activity.status.id && !item.value.activity.uuid,
                                    style: _normalizeStyle({ width: `${String(item.value.activity.points).length + 4 || 4}ch` }),
                                    onInput: _cache[2] || (_cache[2] = ($event) => (item.value.activity.points = _unref(validateNumericInput)(item.value.activity.points), handleUpdate()))
                                }, null, 44, _hoisted_5), [
                                    [_vModelText, item.value.activity.points]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "premialita-title" }, " Elenco Adesioni: ", -1)),
                            _createElementVNode("div", _hoisted_6, [
                                (item.value.activity.campaign.offers?.filter(o => o.status?.name === 'PUBLISHED').length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Nessuna offerta disponibile pubblicata "))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.value.activity.campaign.offers.filter(o => o.status?.name === 'PUBLISHED'), (offer) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: offer.uuid,
                                            class: _normalizeClass([{ 'disabled-state': !item.value.activity.status.id && !item.value.activity.uuid }, "d-flex flex-row align-items-center gap-1 justify-content-between pb-2"])
                                        }, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("img", {
                                                    src: offer.images[0]?.thumb,
                                                    alt: offer.images[0]?.alt,
                                                    class: "offers-list-img my-1"
                                                }, null, 8, _hoisted_9),
                                                _createElementVNode("div", _hoisted_10, _toDisplayString(offer.name), 1)
                                            ]),
                                            _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                style: { "cursor": "pointer" },
                                                checked: item.value.offers?.some(activityOffer => activityOffer.uuid === offer.uuid),
                                                onChange: ($event) => (toggleOffer(offer))
                                            }, null, 40, _hoisted_11)
                                        ], 2));
                                    }), 128))
                            ])
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["d-flex flex-column align-items-center gap-16px", { 'disabled-state': !item.value.activity.status.id && !item.value.activity.uuid }])
                    }, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "premialita-title" }, "Prova Ingresso |QR Code|", -1)),
                        _createElementVNode("canvas", {
                            ref_key: "qrCanvas",
                            ref: qrCanvas
                        }, null, 512),
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(ButtonComponent, {
                                class: "bg-white",
                                text: "Download PDF",
                                type: "regular",
                                onHandleClick: downloadPDF
                            }),
                            _createVNode(ButtonComponent, {
                                class: "bg-primary-custom",
                                text: "Rigenera QR Code",
                                type: "primary",
                                onHandleClick: _cache[3] || (_cache[3] = ($event) => (showModalQR.value = true))
                            })
                        ])
                    ], 2)
                ]),
                _createVNode(BaseModal, {
                    isOpen: showModalQR.value,
                    name: "warning-modal"
                }, {
                    header: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("h3", null, "Avvertimento!", -1)
                        ]))]),
                    content: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("h5", null, [
                                _createTextVNode("Rigenerando il QR code, "),
                                _createElementVNode("b", null, "quello attuale non sarà più valido"),
                                _createTextVNode(" e dovrà essere "),
                                _createElementVNode("b", null, "sostituito con il nuovo codice"),
                                _createTextVNode(" in tutti i punti in cui è utilizzato."),
                                _createElementVNode("br"),
                                _createTextVNode(" Si "),
                                _createElementVNode("b", null, "consiglia di procedere con questa operazione al di fuori degli orari di attività del museo"),
                                _createTextVNode(", per evitare disservizi ai visitatori."),
                                _createElementVNode("br"),
                                _createElementVNode("br"),
                                _createTextVNode(" Vuoi continuare?")
                            ], -1)
                        ]))]),
                    footer: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(ButtonComponent, {
                                text: "Conferma",
                                type: "primary",
                                class: "bg-primary-custom",
                                isDisable: false,
                                onHandleClick: _cache[4] || (_cache[4] = () => { generateQRCode(); showModalQR.value = false; })
                            }),
                            _createVNode(ButtonComponent, {
                                text: "Annulla",
                                type: "regular",
                                class: "bg-white",
                                isDisable: false,
                                onHandleClick: _cache[5] || (_cache[5] = () => showModalQR.value = false)
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen"])
            ], 64));
        };
    }
});
